import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastTone = 'success' | 'error' | 'info' | 'warning'
export interface ToastItem {
  id: number
  message: string
  tone: ToastTone
}

interface ConfirmOptions {
  title: string
  message: string
  confirmLabel?: string
  tone?: 'primary' | 'danger'
}

export const useUiStore = defineStore('ui', () => {
  const toasts = ref<ToastItem[]>([])
  const sidebarOpen = ref(false)
  const sidebarCollapsed = ref(localStorage.getItem('sidebar-collapsed') === '1')
  const confirmState = ref<(ConfirmOptions & { resolve: (value: boolean) => void }) | null>(null)
  let toastId = 0

  function toast(message: string, tone: ToastTone = 'info') {
    const item = { id: ++toastId, message, tone }
    toasts.value.push(item)
    window.setTimeout(() => dismissToast(item.id), 4200)
  }

  function dismissToast(id: number) {
    toasts.value = toasts.value.filter((item) => item.id !== id)
  }

  function toggleCollapsed() {
    sidebarCollapsed.value = !sidebarCollapsed.value
    localStorage.setItem('sidebar-collapsed', sidebarCollapsed.value ? '1' : '0')
  }

  function confirm(options: ConfirmOptions) {
    return new Promise<boolean>((resolve) => {
      confirmState.value = { ...options, resolve }
    })
  }

  function resolveConfirm(result: boolean) {
    confirmState.value?.resolve(result)
    confirmState.value = null
  }

  return { toasts, sidebarOpen, sidebarCollapsed, confirmState, toast, dismissToast, toggleCollapsed, confirm, resolveConfirm }
})
